import React from "react";
import { ButtonGroup } from "react-bootstrap";
import { Pencil } from "react-bootstrap-icons";

interface CustomEditButtonProps {
  onClick: (
    event: React.MouseEvent<HTMLButtonElement>,
    id: number,
    option?: any,
    isDisable?: boolean,
  ) => void;
  id: number;
  isDisabled?: boolean;
  style?: any;
}

const CustomEditButton: React.FC<CustomEditButtonProps> = ({
  onClick,
  id,
  isDisabled,
  style,
}) => {
  return (
    <ButtonGroup>
      <button
        className="btn btn-xs border-0"
        disabled={isDisabled}
        onClick={(e) => onClick(e, id)}
        title="Edit"
        style={style && style}
      >
        <Pencil
          className="ml-4"
          style={{ fill: isDisabled ? "rgb(106 106 106)" : "#0D6EFD" }}
        />
      </button>
    </ButtonGroup>
  );
};

export default CustomEditButton;
